import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Container, Loading } from "@/components/atoms";
import { GeneralFooter, GeneralHeader } from "@/components/organisms";
import { SignUpFormInvite } from "@/components/organisms/SignUp/forms/SignUpInviteForm";
import { useOperator } from "@/hooks";
import { useLazyGetProviderQuery, useVerifyProviderTokenQuery } from "@/redux/apis/auth/authApi";
import { useAppDispatch } from "@/redux/hooks";
import { setActiveOperator } from "@/redux/slices/operator/operatorSlice";
import { Restricted, Expired } from "..";

export const SignUpInvite = () => {
  const dispatch = useAppDispatch();
  const { token } = useParams();
  const { singleTenant } = useOperator();
  const { isLoading: isVerifying, isSuccess: isValidToken, data, isError: isErrorVerify } = useVerifyProviderTokenQuery(token || "");
  const [getProvider, { isLoading, isError: isErrorGet }] = useLazyGetProviderQuery();
  const signUpEnabled = singleTenant;
  const isError = isErrorVerify || isErrorGet;

  useEffect(() => {
    if (isValidToken && data) {
      getProvider(data.provider_uuid)
        .unwrap()
        .then((operator) => dispatch(setActiveOperator(operator)));
    }
  }, [token, getProvider, data, isValidToken, dispatch]);

  if (isVerifying || isLoading) return <Loading />;
  if (!token || isError)
    return (
      <Expired
        title="Invitation Expired"
        description="Sorry, the link invitation is not valid anymore. Please contact the person who invited you."
      />
    );

  return (
    <div className="flex min-h-screen flex-col overflow-hidden md:flex-row">
      <div className="relative flex flex-1 flex-col">
        <GeneralHeader action="login" />
        {signUpEnabled && data ? (
          <Container className="flex w-full max-w-[1040px] flex-1 justify-center gap-5 px-5 py-8 md:py-[100px]">
            <SignUpFormInvite email={data.email} inviteToken={token} />
          </Container>
        ) : (
          <Restricted />
        )}
        <GeneralFooter />
      </div>
    </div>
  );
};
